import { FC } from 'react';

import ReactSelect from 'react-select';

import { useGetWalletSectionSettingsQuery } from '@entities/wallets';
import { reactSelectStyles } from '@shared/components/Form';

interface IProps {
  name: string;
  selectedValue?: string;
}

export const WalletKindsSelect: FC<IProps> = ({ name, selectedValue }) => {
  const { data, isLoading } = useGetWalletSectionSettingsQuery();
  const kinds = data?.data?.kinds ?? [];

  const options = kinds.map(k => ({ label: k.toUpperCase(), value: k }));
  const defaultValue = selectedValue
    ? { label: selectedValue.toUpperCase(), value: selectedValue }
    : null;

  return (
    <ReactSelect
      name={name}
      options={options}
      defaultValue={defaultValue}
      isClearable
      isLoading={isLoading}
      styles={reactSelectStyles()}
      menuPosition='fixed'
      maxMenuHeight={200}
    />
  );
};
